import React from "react";
import { Checkbox, FormControlLabel, SvgIcon, TextField } from "@mui/material";
import { mdiCheckboxMarked, mdiRotate360 } from "@mdi/js";
import { styled } from "@mui/material/styles";
import { getDir } from "orion-components/i18n/Config/selector";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { getTranslation } from "orion-components/i18n";
import { useEffect } from "react";

const formControlLabelStyle = {
	"& .MuiFormControlLabel-label": {
		fontSize: 11,
		color: "#FFFFFF"
	}
};

const CustomizedTextField = styled(TextField)({
	"& label": {
		color: "#9A9FA3",
		fontSize: 12
	},
	"& label.Mui-focused": {
		color: "#9A9FA3"
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#5E6571"
		},
		"&:hover fieldset": {
			borderColor: "#4DB5F4"
		},
		"&.Mui-focused fieldset": {
			borderColor: "#4DB5F4"
		}
	}
});
const ConstrainProportions = ({ shapeType }) => {
	const dir = useSelector(state => getDir(state));
	const [aspectRatio, setAspectRatio] = useState(true);
	const dispatch = useDispatch();
	const constrainProportionVal = useSelector(state => state.shapes[shapeType].constrainProportion);
	const toggleConstrainProportion = () => {
		setAspectRatio(!aspectRatio);
		dispatch(createOrUpdateShape(shapeType, { constrainProportion: !aspectRatio }));
	};

	useEffect(() => {
		setAspectRatio(constrainProportionVal);
	}, [constrainProportionVal]);

	return (
		<div
			style={{
				marginTop: 24,
				...(dir === "ltr" && { marginLeft: 20 }),
				...(dir === "rtl" && { marginRight: 20 })
			}}
		>
			<div style={{ display: "flex", alignItems: "center" }}>
				<div
					style={{
						...(dir === "ltr" && { marginRight: 39.5 }),
						...(dir === "rtl" && { marginLeft: 39.5 })
					}}
				>
					<FormControlLabel
						control={
							<Checkbox
								checkedIcon={
									<SvgIcon
										style={{
											width: "24px",
											height: "24px",
											color: "#4DB5F4",
											transform: "scale(0.9)"
										}}
									>
										<path d={mdiCheckboxMarked} />
									</SvgIcon>
								}
								checked={aspectRatio}
								onChange={toggleConstrainProportion}
							/>
						}
						sx={formControlLabelStyle}
						label={getTranslation(
							"global.sharedComponents.shapeEditor.components.constrainProportions.label"
						)}
					/>
				</div>
				{/* <div style={{ ...(dir === "ltr" && { marginRight: 11 }), ...(dir === "rtl" && { marginLeft: 11 }) }}>
					<SvgIcon
						style={{
							width: 20,
							height: 13,
							color: "#A7ACB0"
						}}
					>
						<path d={mdiRotate360} />
					</SvgIcon>
				</div>
				<div>
					<CustomizedTextField
						value="0"
						variant="outlined"
						inputProps={{
							style: { color: "#FFFFFF", fontSize: 12, fontFamily: "Roboto", textAlign: "left" }
						}}
						sx={{ width: 53, height: 43 }}
					/>
				</div> */}
			</div>
		</div>
	);
};

export default ConstrainProportions;
